

























































































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { AxiosError } from 'axios';

import PageHeader from '@/components/Profile/ProfileDetailHeader.vue';

export default Vue.extend({
    name: 'Vop',

    data() {
        return {
            agreed: false,
            state: 'idle',
        };
    },

    created() {
        this.agreed = this.getUserTermsAgreed;
    },

    methods: {
        continueClick() {
            if (this.getUserTermsAgreed) {
                return this.next();
            }

            if (this.agreed) {
                this.agree();
            }
        },

        agree() {
            this.state = 'saving';
            this.$store
                .dispatch('agreeTerms')
                .then(() => {
                    this.state = 'saved';
                    this.next();
                })
                .catch((err: AxiosError) => {
                    this.state = 'error';
                    let msg: string;
                    switch (err.response.data.error) {
                        case 'user_already_agreed':
                            msg = "User already agreed terms, something's wrong...";
                            break;
                        default:
                            msg = err.response.data.error_description;
                    }
                    this.$bugsnag.notify(err);
                    setTimeout(() => alert(msg), 300);
                })
                .finally(() => {
                    this.state = 'idle';
                });
        },

        next() {
            const returnUrl = this.$route.query.returnUrl;
            if (returnUrl) {
                this.$router.push({ path: returnUrl });
            } else {
                var name = window.matchMedia('(min-width: 768px)').matches ? 'profile-voice' : 'profile-intro';
                this.$router.push({ name });
            }
        },
    },

    computed: {
        ...mapGetters(['getUserTermsAgreed']),
    },

    watch: {
        state(newVal) {
            switch (newVal) {
                case 'idle':
                    break;
                case 'saving':
                    this.$refs.continueBtn.setLoading();
                    break;
                case 'saved':
                    this.$refs.continueBtn.setSuccess('Success');
                    break;
                case 'error':
                    this.$refs.continueBtn.setError('Failed');
                    break;
            }
        },
    },

    components: {
        PageHeader,
    },
});
